var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.hideSidebar)?_c('div',{staticClass:"admin"},[_c('Sidebar'),_c('main',{staticClass:"fullPage"},[_c('Header'),_c('router-view')],1)],1):_c('div',{staticClass:"adminNoSidebar"},[_c('main',[_c('Header'),_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }